// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Skills.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  CreateSkillRequest,
  CreateSkillResponse,
  CreateSkillReviewRequest,
  CreateSkillReviewResponse,
  GetPendingReviewSkillsRequest,
  GetPendingReviewSkillsResponse,
  GetRequiredSkillsRequest,
  GetRequiredSkillsResponse,
  GetSkillByIdRequest,
  GetSkillByIdResponse,
  GetSkillReviewsRequest,
  GetSkillReviewsResponse,
  GetSkillsByAccountRequest,
  GetSkillsByAccountResponse,
  UpdateSkillRequest,
  UpdateSkillResponse,
} from "./Models/SkillModels";

export const protobufPackage = "daisi.protos.v1";

export type SkillsProtoDefinition = typeof SkillsProtoDefinition;
export const SkillsProtoDefinition = {
  name: "SkillsProto",
  fullName: "daisi.protos.v1.SkillsProto",
  methods: {
    getSkillsByAccount: {
      name: "GetSkillsByAccount",
      requestType: GetSkillsByAccountRequest,
      requestStream: false,
      responseType: GetSkillsByAccountResponse,
      responseStream: false,
      options: {},
    },
    getSkillById: {
      name: "GetSkillById",
      requestType: GetSkillByIdRequest,
      requestStream: false,
      responseType: GetSkillByIdResponse,
      responseStream: false,
      options: {},
    },
    createSkill: {
      name: "CreateSkill",
      requestType: CreateSkillRequest,
      requestStream: false,
      responseType: CreateSkillResponse,
      responseStream: false,
      options: {},
    },
    updateSkill: {
      name: "UpdateSkill",
      requestType: UpdateSkillRequest,
      requestStream: false,
      responseType: UpdateSkillResponse,
      responseStream: false,
      options: {},
    },
    getPendingReviewSkills: {
      name: "GetPendingReviewSkills",
      requestType: GetPendingReviewSkillsRequest,
      requestStream: false,
      responseType: GetPendingReviewSkillsResponse,
      responseStream: false,
      options: {},
    },
    createSkillReview: {
      name: "CreateSkillReview",
      requestType: CreateSkillReviewRequest,
      requestStream: false,
      responseType: CreateSkillReviewResponse,
      responseStream: false,
      options: {},
    },
    getSkillReviews: {
      name: "GetSkillReviews",
      requestType: GetSkillReviewsRequest,
      requestStream: false,
      responseType: GetSkillReviewsResponse,
      responseStream: false,
      options: {},
    },
    getRequiredSkills: {
      name: "GetRequiredSkills",
      requestType: GetRequiredSkillsRequest,
      requestStream: false,
      responseType: GetRequiredSkillsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface SkillsProtoServiceImplementation<CallContextExt = {}> {
  getSkillsByAccount(
    request: GetSkillsByAccountRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetSkillsByAccountResponse>>;
  getSkillById(
    request: GetSkillByIdRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetSkillByIdResponse>>;
  createSkill(
    request: CreateSkillRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateSkillResponse>>;
  updateSkill(
    request: UpdateSkillRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UpdateSkillResponse>>;
  getPendingReviewSkills(
    request: GetPendingReviewSkillsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetPendingReviewSkillsResponse>>;
  createSkillReview(
    request: CreateSkillReviewRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateSkillReviewResponse>>;
  getSkillReviews(
    request: GetSkillReviewsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetSkillReviewsResponse>>;
  getRequiredSkills(
    request: GetRequiredSkillsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetRequiredSkillsResponse>>;
}

export interface SkillsProtoClient<CallOptionsExt = {}> {
  getSkillsByAccount(
    request: DeepPartial<GetSkillsByAccountRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetSkillsByAccountResponse>;
  getSkillById(
    request: DeepPartial<GetSkillByIdRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetSkillByIdResponse>;
  createSkill(
    request: DeepPartial<CreateSkillRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateSkillResponse>;
  updateSkill(
    request: DeepPartial<UpdateSkillRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UpdateSkillResponse>;
  getPendingReviewSkills(
    request: DeepPartial<GetPendingReviewSkillsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetPendingReviewSkillsResponse>;
  createSkillReview(
    request: DeepPartial<CreateSkillReviewRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateSkillReviewResponse>;
  getSkillReviews(
    request: DeepPartial<GetSkillReviewsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetSkillReviewsResponse>;
  getRequiredSkills(
    request: DeepPartial<GetRequiredSkillsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetRequiredSkillsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
